<app-basic-page class="" title="Verträge">
  <div class="grid grid-cols-1 xl:grid-cols-5 h-full  gap-4">
    <div class="xl:col-span-2 flex flex-col xl:border-r-2 xl:border-gray-400 panel overflow-y-auto">
      <div>
        <div class="space-y-4">
          <!-- Active: "border-theme-primary-700 ring-2 ring-theme-primary-700", Not Active: "border-gray-300" -->
          <div (click)="company_select(company)" *ngFor="let company of companies_filtered"
               [ngClass]="{'!border-theme-primary-700 !ring-2 !ring-theme-primary-700': company_selected?.id == company.id}"
               class="relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between">
          <span class="flex items-center">
            <span class="flex flex-col text-sm">
              <span class="font-medium text-gray-900">{{ company.name }}</span>
              <span class="text-gray-500 flex flex-col">
                <div *ngFor="let shard of company.shards" class="inline-flex gap-x-1">
                  <span class="place-self-center">&middot;</span>
                <span class="place-self-center">{{ shard.name }}</span>
                </div>
              </span>
            </span>
          </span>
            <span *ngIf="false" class="mt-2 flex text-sm sm:ml-4 sm:mt-0 sm:flex-col sm:text-right">
            <span class="font-medium text-gray-900">$40</span>
            <span class="ml-1 text-gray-500 sm:ml-0">/mo</span>
          </span>
            <!--
              Active: "border", Not Active: "border-2"
              Checked: "border-theme-primary-700", Not Checked: "border-transparent"
            -->
            <span aria-hidden="true" class="pointer-events-none absolute -inset-px rounded-lg border-2"></span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="company_details" class="xl:col-span-3 flex flex-col overflow-y-auto px-4">
      <div class="flex flex-col xl:inline-flex">
        <span class="header">{{ company_details.name }}</span>
      </div>
      @if (!company_contract_edit_mode) {
        <div class="grid grid-cols-2 xl:grid-cols-4 gap-4 py-4">
          @if (company_details_contract_current) {
            <div class="item col-span-2 xl:col-span-4">
              <span class="title h-full">Zeitraum</span>
              <span class="">{{ company_contract_current()?.validFrom | dayKey:'long' }}
                - {{ company_contract_current()?.validTo | dayKey:'long' }}</span>
            </div>
            <div class="item">
              <span class="title">Shards</span>
              <span class="number">
            <span *ngIf="company_values">{{ company_values.item1?.shardCount }}&nbsp;/</span>
                {{ company_contract_current()?.shardCount }}</span>
            </div>
            <div class="item">
              <span class="title">Geräte</span>
              <span class="number">
            <span *ngIf="company_values">{{ company_values.item1?.deviceCount }}&nbsp;/</span>
                {{ company_contract_current()?.deviceCount }}</span>
            </div>
            <div class="item">
              <span class="title">Mindestlaufzeit</span>
              <span class="text">
            {{ company_contract_current()?.minimalMonthsPerDevice }} Monate</span>
            </div>
            <div class="item">
              <span class="title">Virtuelle Events</span>
              <span class="number">
            {{ company_contract_current()?.virtualEventCount == -1 ? "&infin;" : company_contract_current()?.virtualEventCount }}</span>
            </div>
          }
          <div class="item">
            <span class="title">Aktionen</span>
            <div class="flex">
              <button *ngIf="company_details_contract_current"
                      (click)="company_contract.load(company_details_contract_current); company_contract_edit_mode = true;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5"
                        d="m5 16l-1 4l4-1L19.586 7.414a2 2 0 0 0 0-2.828l-.172-.172a2 2 0 0 0-2.828 0zM15 6l3 3m-5 11h8"/>
                </svg>
              </button>
              <button (click)="company_contract.reset();company_contract_edit_mode = true;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M18 12c-.55 0-1 .45-1 1v5.22c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1m3.02-7H19V2.98c0-.54-.44-.98-.98-.98h-.03c-.55 0-.99.44-.99.98V5h-2.01c-.54 0-.98.44-.99.98v.03c0 .55.44.99.99.99H17v2.01c0 .54.44.99.99.98h.03c.54 0 .98-.44.98-.98V7h2.02c.54 0 .98-.44.98-.98v-.04c0-.54-.44-.98-.98-.98"/>
                  <path
                    d="M14 9H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1m0 3H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1m0 3H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="rounded-2xl bg-white p-4 shadow-2xl flex flex-col mb-4"
             *ngIf="company_details_contract_upcoming.length > 0">
          <span class="text-xl text-theme-primary-700 font-bold w-full pb-2">Zukünftige Verträge</span>
          <app-contract-information *ngFor="let contract of company_details_contract_upcoming" [contract]="contract"
                                    (edit)="company_contract.load($event); company_contract_edit_mode = true"
                                    [canEdit]="true"/>
        </div>
        <div class="rounded-2xl bg-white p-4 shadow-2xl flex flex-col mb-4"
             *ngIf="company_details_contract_past.length > 0">
          <span class="text-xl text-gray-500 font-bold w-full pb-2">Vergangene Verträge</span>
          <app-contract-information *ngFor="let contract of company_details_contract_past" [contract]="contract"
                                    (edit)="company_contract.load($event); company_contract_edit_mode = true"
                                    [canEdit]="true"/>
        </div>
      } @else if (company_details && company_contract_edit_mode) {
        <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3 py-4">
          <div>
            <h2 class="text-base font-semibold leading-7 text-gray-900">Vertragsinformationen</h2>
            <p class="mt-1 text-xs leading-6 text-gray-600">{{ company_contract.id }}</p>
          </div>

          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
            <div class="sm:col-span-3">
              <label for="start-date" class="block text-sm font-medium leading-6 text-gray-900">Startdatum</label>
              <div class="mt-2">
                <input type="date" name="start-date" id="start-date"
                       [(ngModel)]="company_contract.start"
                       class="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
              </div>
            </div>

            <div class="sm:col-span-3">
              <label for="end-date" class="block text-sm font-medium leading-6 text-gray-900">Enddatum</label>
              <div class="mt-2">
                <input type="date" name="end-date" id="end-date" [(ngModel)]="company_contract.end"
                       class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
              </div>
            </div>

            @if (false) {
              <div class="sm:col-span-4">
                <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
                <div class="mt-2">
                  <input id="email" name="email" type="email" autocomplete="email"
                         class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
                </div>
              </div>

              <div class="sm:col-span-3">
                <label for="country" class="block text-sm font-medium leading-6 text-gray-900">Country</label>
                <div class="mt-2">
                  <select id="country" name="country" autocomplete="country-name"
                          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:max-w-xs sm:text-sm sm:leading-6">
                    <option>United States</option>
                    <option>Canada</option>
                    <option>Mexico</option>
                  </select>
                </div>
              </div>

              <div class="col-span-full">
                <label for="street-address" class="block text-sm font-medium leading-6 text-gray-900">Street
                  address</label>
                <div class="mt-2">
                  <input type="text" name="street-address" id="street-address" autocomplete="street-address"
                         class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
                </div>
              </div>
            }

            <div class="sm:col-span-2 sm:col-start-1">
              <label for="shard-count" class="block text-sm font-medium leading-6 text-gray-900">Anzahl Shards</label>
              <div class="mt-2">
                <input name="shard-count" id="shard-count" autocomplete="shard-count"
                       [(ngModel)]="company_contract.shard_count"
                       type="number" min="1" max="10" step="1"
                       class="text-center block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
              </div>
            </div>

            <div class="sm:col-span-2">
              <label for="device-count" class="block text-sm font-medium leading-6 text-gray-900">Anzahl Geräte</label>
              <div class="mt-2">
                <input type="number" min="1" max="100" step="1" [(ngModel)]="company_contract.device_count"
                       name="device-count" id="device-count" autocomplete="device-count"
                       class="text-center block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
              </div>
            </div>

            <div class="sm:col-span-2">
              <label for="device-minimum-months" class="block text-sm font-medium leading-6 text-gray-900">Mindestlaufzeit</label>
              <div class="mt-2">
                <input type="number" min="1" max="12" step="1" [(ngModel)]="company_contract.device_minimum_months"
                       name="device-minimum-months" id="device-minimum-months" autocomplete="device-minimum-months"
                       class="text-center block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
              </div>
            </div>

            <!-- #664. `min="-1"` because `-1` is the documented "unbegrenzt" sentinel this whole screen
                 already uses for shards and devices; the hint spells it out rather than leaving the reader to
                 discover that a negative number is legal here. -->
            <div class="sm:col-span-2">
              <label for="virtual-event-count" class="block text-sm font-medium leading-6 text-gray-900">Virtuelle
                Events (parallel)</label>
              <div class="mt-2">
                <input type="number" min="-1" max="100" step="1" [(ngModel)]="company_contract.virtual_event_count"
                       name="virtual-event-count" id="virtual-event-count" autocomplete="off"
                       aria-describedby="virtual-event-count-hint"
                       class="text-center block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6">
                <p id="virtual-event-count-hint" class="mt-2 text-xs text-gray-500">-1 = unbegrenzt</p>
              </div>
            </div>

            <div class="sm:col-span-6 inline-flex gap-x-4">
              <a class="text-red-600 hover:text-red-800 place-self-center" (click)="delete()"
                 *ngIf="company_contract.id">Löschen</a>
              <a class="ml-auto text-gray-700 hover:text-gray-500 place-self-center"
                 (click)="company_contract_edit_mode = false; company_contract.reset()">Abbrechen</a>
              <button (click)="save()"
                      class="px-2 py-1 rounded-md text-theme-primary-700 border-2 border-theme-primary-700">{{ company_contract.id ? "Speichern" : "Hinzufügen" }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</app-basic-page>

